<template>
  <div class="cmd-box">
    <div class="btn-only">
      <!-- <div class="select-field">
        <label>Select Command:</label>
        <select v-model="selectedCommand">
          <option v-for="cmd in commands" :value="cmd.value" :key="cmd.value">{{ cmd.text }}</option>
        </select>
      </div> -->
      <div class="btns">
        <div class="button cta primary" @click="confirm('Flush Host')">FLUSH Hosts</div>
        <div class="button cta warning" @click="confirm('Unstuck DB')">Unstuck DB</div>
        <div class="button cta success" @click="confirm('Create Reservation')" v-if="env !== 'production'">CREATE RES</div>
      </div>
    </div>

    <div class="field-box" >
      <label>Consumer ID</label>
      <div class="d-flex align-center fields">
        <input v-model="consumer.email" placeholder="Email" :class="['email', {'error':error.consumerEmail}]" />
        <input v-model="consumer.level" placeholder="Level (Optional)" class="level" />
        <div class="button cta small" @click="submitAction('Consumer ID')">SUBMIT</div>
      </div>
    </div>

    <div class="field-box"  >
      <label>Remove CB</label>
      <div class="d-flex align-center fields">
        <input type="text" placeholder="RSVP ID" :class="['rsvpid', {'error':error.removeCBRsvpID}]" v-model="removeCBRsvpID" />
        <div class="button cta small" @click="submitAction('Remove CB')">SUBMIT</div>
      </div>
    </div>

    <div class="field-box"  >
      <label>Force No Show</label>
      <div class="d-flex align-center fields">
        <input type="text" placeholder="RSVP ID" :class="['rsvpid', {'error':error.forceNoShowRsvpID}]" v-model="forceNoShowRsvpID" />
        <div class="button cta small" @click="submitAction('Force No Show')">SUBMIT</div>
      </div>
    </div>

    <div class="field-box"  >
      <label>Force Complete</label>
      <div class="d-flex align-center fields">
        <input type="text" placeholder="RSVP ID" :class="['rsvpid', {'error':error.forceCompleteRsvpID}]" v-model="forceCompleteRsvpID" />
        <div class="button cta small" @click="submitAction('Force Complete')">SUBMIT</div>
      </div>
    </div>

    <div class="field-box"  >
      <label>Force Cancel</label>
      <div class="d-flex align-center fields">
        <input type="text" placeholder="RSVP ID" :class="['rsvpid', {'error':error.forceCancelRsvpID}]" v-model="forceCancelRsvpID" />
        <div class="button cta small" @click="submitAction('Force Cancel')">SUBMIT</div>
      </div>
    </div>

    <div class="field-box"  >
      <label>Remove M&G</label>
      <div class="d-flex align-center fields">
        <input type="text" placeholder="RSVP ID" :class="['rsvpid', {'error':error.removeMNGRsvpID}]" v-model="removeMNGRsvpID" />
        <div class="button cta small" @click="submitAction('Remove M&G')">SUBMIT</div>
      </div>
    </div>

    <div class="field-box"  >
      <label>Reset RSVP</label>
      <div class="d-flex align-center fields">
        <input type="text" placeholder="RSVP ID" :class="['rsvpid', {'error':error.resetRsvpID}]" v-model="resetRsvpID" />
        <div class="button cta small" @click="submitAction('Reset RSVP')">SUBMIT</div>
      </div>
    </div>

    <div class="field-box"  >
      <label>Undo No Show</label>
      <div class="d-flex align-center fields">
        <input type="text" placeholder="RSVP ID" :class="['rsvpid', {'error':error.undoNoShowRsvpID}]" v-model="undoNoShowRsvpID" />
        <div class="button cta small" @click="submitAction('Undo No Show')">SUBMIT</div>
      </div>
    </div>

    <div class="field-box"  >
      <label>Undo Complete</label>
      <div class="d-flex align-center fields">
        <input type="text" placeholder="RSVP ID" :class="['rsvpid', {'error':error.undoCompleteRsvpID}]" v-model="undoCompleteRsvpID" />
        <div class="button cta small" @click="submitAction('Undo Complete')">SUBMIT</div>
      </div>
    </div>

    <div class="field-box"  >
      <label>Driver Payment</label>
      <div class="d-flex align-center fields">
        <input type="text" placeholder="RSVP ID" :class="['rsvpid', {'error':error.driverPaymentRsvpID}]" v-model="driverPayment.rsvpId" />
        <input type="text" placeholder="Amount" :class="['level', {'error':error.driverPaymentAmount}]" v-model="driverPayment.amount" />
        <div class="button cta small" @click="submitAction('Driver Payment')">SUBMIT</div>
      </div>
    </div>

    <div class="field-box"  >
      <label>Private Van</label>
      <div class="d-flex align-center fields">
        <input type="text" placeholder="RSVP ID" :class="['rsvpid', {'error':error.privateVanRsvpID}]" v-model="privateVanRsvpID" />
        <div class="button cta small" @click="submitAction('Private Van')">SUBMIT</div>
      </div>
    </div>

    <div class="field-box"  >
      <label>Not Failed</label>
      <div class="d-flex align-center fields">
        <input type="text" placeholder="RSVP ID" :class="['rsvpid', {'error':error.notFailedRsvpID}]" v-model="notFailedRsvpID" />
        <div class="button cta small" @click="submitAction('Not Failed')">SUBMIT</div>
      </div>
    </div>

    <div :class="['lr-modal', {'hide': !show}]">
      <div class="lr-box">
        <div class="lr-alert-msg">
          Are you sure you want to run
          <b>{{ confirmTarget }}</b>?
        </div>
        <div class="d-flex justify-space-around btns">
          <a class="button cta small secondary block" @click="show = false">Cancel</a>
          <a class="button cta small primary block" @click="btnTrigger">Confirm</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'

export default {
  name: 'commands',
  data () {
    return {
      env: 'production',
      show: false,
      selectedCommand: null,
      commands: [
        {value: 'consumerId', text: 'Consumer ID'},
        {value: 'removeCB', text: 'Remove CB'},
        {value: 'forceNoShow', text: 'Force No Show'},
        {value: 'forceComplete', text: 'Force Complete'},
        {value: 'forceCancel', text: 'Force Cancel'},
        {value: 'removeMG', text: 'Remove M&G'},
        {value: 'resetRSVP', text: 'Reset RSVP'},
        {value: 'undoNoShow', text: 'Undo No Show'},
        {value: 'undoComplete', text: 'Undo Complete'},
        {value: 'driverPayment', text: 'Driver Payment'},
        {value: 'privateVan', text: 'Private Van'},
        {value: 'notFailed', text: 'Not Failed'}
      ],
      confirmTarget: '',
      consumer: {
        email: '',
        level: 1
      },
      removeCBRsvpID: '',
      forceNoShowRsvpID: '',
      forceCompleteRsvpID: '',
      forceCancelRsvpID: '',
      removeMNGRsvpID: '',
      resetRsvpID: '',
      undoNoShowRsvpID: '',
      undoCompleteRsvpID: '',
      driverPayment: {
        rsvpId: '',
        amount: ''
      },
      privateVanRsvpID: '',
      notFailedRsvpID: '',
      error: {
        consumerEmail: '',
        removeCBRsvpID: '',
        forceNoShowRsvpID: '',
        forceCompleteRsvpID: '',
        forceCancelRsvpID: '',
        removeMNGRsvpID: '',
        resetRsvpID: '',
        undoNoShowRsvpID: '',
        undoCompleteRsvpID: '',
        driverPaymentRsvpID: '',
        driverPaymentAmount: '',
        privateVanRsvpID: '',
        notFailedRsvpID: ''
      }
    }
  },
  computed: {
  },
  methods: {
    confirm (x) {
      this.confirmTarget = x
      this.show = true
    },
    btnTrigger () {
      let self = this
      self.show = false
      self.$store.commit('global/setLoaderData', {show: true})

      if (self.confirmTarget === 'Create Reservation') {
        let param = {
          "token":"USER-811b6ae3-5ab6-4bdf-a956-71b7efbb2624",
          "brandId":8,
          "guest":null,
          "legs":[
            {"pickup":{"address1":"Disneyland Drive","address2":"1313","city":"Anaheim","state":"CA","zip":"92802","lat":"33.8120918","lng":"-117.91897419999998","title":"1313 Disneyland Dr, Anaheim, CA 92802, USA","geofenceId":294},"dropoff":{"address1":"1","address2":"World Way","city":"Los Angeles","state":"CA","zip":"","lat":"33.9415889","lng":"-118.40852999999998","title":"1 World Way, Los Angeles, CA 90045","geofenceId":12},"pickupTime":"1746303900","passengers":1,"luggage":1,"amount":75.99,"originalPrice":75.99,"airportFee":5,"gasFee":1.73,"flightNumber":"","flightName":"","dropoffFlightName":"American (terminal 5)","dropoffFlightNumber":"2024","asap":false,"etaInSec":3476,"serviceTypeId":39,"pickupType":"","pickupFee":0,"distance":34.564393926192,"notes":"","travelInsurance":5.18,"tip":0},
            null
          ],
          "payment":{"cardID":1023,"tip":0,"total":"87.90","fare":"87.90","pickupFee":0,"promo":0},
          "wheelchair":0,
          "serviceDog":0,
          "source":"C",
          "deviceType":"ww",
          "hudson":false
        }
        param.legs[0].pickupTime = moment().add(1, 'hour').format('X')
        self.$sdk.post('/reservations', param, r => {
          self.$store.commit('global/setLoaderData', {show: false})
          if (r.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: r.error.message
            })
            return
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: `RES CREATED! <b><a target="_blank" href="/#/reservation/${r.reservationId[0]}">${r.reservationId[0]}</a></b>`
          })
        })
        return
      }

      let url = '/utils/flushhosts'
      if (self.confirmTarget === 'Unstuck DB') url = '/utils/unstuck'
      self.$sdk.get(url, {}, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: `<b>${self.confirmTarget}</b> SUCCESS!`
        })
      }, '')
    },
    submitAction (x) {
      let self = this
      let param = {}
      let url = ''
      if (x === 'Consumer ID') {
        url = '/utils/consid'
        param = { email: self.consumer.email, level: self.consumer.level || 1 }
        self.error.consumerEmail = ''
        if (!param.email) {
          self.error.consumerEmail = 'error'
          return
        }
      }
      if (x === 'Remove CB') {
        url = '/utils/removecb'
        param = { rsvpId: self.removeCBRsvpID }
        self.error.removeCBRsvpID = ''
        if (!param.rsvpId) {
          self.error.removeCBRsvpID = 'error'
          return
        }
      }
      if (x === 'Force No Show') {
        url = '/utils/forcenoshow'
        param = { rsvpId: self.forceNoShowRsvpID }
        self.error.forceNoShowRsvpID = ''
        if (!param.rsvpId) {
          self.error.forceNoShowRsvpID = 'error'
          return
        }
      }
      if (x === 'Force Complete') {
        url = '/utils/forcecomplete'
        param = { rsvpId: self.forceCompleteRsvpID }
        self.error.forceCompleteRsvpID = ''
        if (!param.rsvpId) {
          self.error.forceCompleteRsvpID = 'error'
          return
        }
      }
      if (x === 'Force Cancel') {
        url = '/utils/forcecancel'
        param = { rsvpId: self.forceCancelRsvpID }
        self.error.forceCancelRsvpID = ''
        if (!param.rsvpId) {
          self.error.forceCancelRsvpID = 'error'
          return
        }
      }
      if (x === 'Remove M&G') {
        url = '/utils/removemng'
        param = { rsvpId: self.removeMNGRsvpID }
        self.error.removeMNGRsvpID = ''
        if (!param.rsvpId) {
          self.error.removeMNGRsvpID = 'error'
          return
        }
      }
      if (x === 'Reset RSVP') {
        url = '/utils/resetrsvp'
        param = { rsvpId: self.resetRsvpID }
        self.error.resetRsvpID = ''
        if (!param.rsvpId) {
          self.error.resetRsvpID = 'error'
          return
        }
      }
      if (x === 'Undo Complete') {
        url = '/utils/undocomplete'
        param = { rsvpId: self.undoCompleteRsvpID }
        self.error.undoCompleteRsvpID = ''
        if (!param.rsvpId) {
          self.error.undoCompleteRsvpID = 'error'
          return
        }
      }
      if (x === 'Driver Payment') {
        url = '/utils/dp'
        param = { rsvpId: self.driverPayment.rsvpId, amount: self.driverPayment.amount }
        self.error.driverPaymentRsvpID = ''
        self.error.driverPaymentAmount = ''
        if (!param.rsvpId) self.error.driverPaymentRsvpID = 'error'
        if (!param.amount) self.error.driverPaymentAmount = 'error'
        if (!param.rsvpId || !param.amount) return
      }
      if (x === 'Private Van') {
        url = '/utils/pv'
        param = { rsvpId: self.privateVanRsvpID }
        self.error.privateVanRsvpID = ''
        if (!param.rsvpId) {
          self.error.privateVanRsvpID = 'error'
          return
        }
      }
      if (x === 'Not Failed') {
        url = '/utils/pv'
        param = { rsvpId: self.notFailedRsvpID }
        self.error.notFailedRsvpID = ''
        if (!param.rsvpId) {
          self.error.notFailedRsvpID = 'error'
          return
        }
      }

      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.get(url, param, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        let msg = `<b>${x}</b> SUCCESS!`
        if (x === 'Consumer ID' && r.results) {
          if (r.results.length) {
            r.results.forEach(con => {
              msg += `<br/>- ${con.ID} ${con.email}`
            })
          } else {
            msg += `<br/>- <i>EMPTY RESULT</i>`
          }
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: msg
        })
      }, '')
    }
  },
  watch: {},
  mounted () {
    this.env = CONFIG.Env
  }
}
</script>

<style lang="scss" scoped>
.cmd-box{
  padding: 15px;
}
.btn-only{
  display: flex;
  gap: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #dfdfdf;
  justify-content: space-between;
  align-items: center;
}

.field-box{
  padding: 20px 0 25px;
  border-bottom: 1px solid #dfdfdf;

  label{
    font-weight: 600;
    line-height: 1;
    font-size: 15px;
    color: #333;
  }
  .fields{
    gap: 10px;
  }
  input{
    margin: 0;
    padding: 5px;
    line-height: 1;
    font-size: 16px;
    letter-spacing: .5px;
    width: 200px;

    &.error{
      border-color: #f00;
    }
  }
  // .email, .rsvpid, .level{
  //   width: 200px;
  // }
}

.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.15s ease-in;
  -moz-transition: all 0.15s ease-in;
  -o-transition: all 0.15s ease-in;
  transition: all 0.15s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
  .btns{
    gap: 10px;
  }
}
.lr-box {
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 3px 3px 2px rgba(0,0,0, .3);
  text-align: center;
  min-width: 300px;
  max-width: 500px;
}

.lr-alert-msg{
  margin-bottom: 20px;
  color: #45505b;
  font-size: 15px;
}

@media only screen and (max-width: 430px){
  .btn-only {
    flex-direction: column-reverse;

    .btns {
      display: flex;
      width: 100%;
      gap: 20px;
      .button {
        padding: 12px 15px 14px;  
      }
    }
  }
  .field-box{
    .fields{
      flex-direction: column;
    }
    input{
      width: 100%;
      border: 1px solid #aaa;
    }

    .button {
      line-height: 14px;
      font-size: 14px;
      padding: 10px 15px 11px;
      width: 100%;
    }
  }
  .lr-box{
    padding: 10px;
  }

  .btn-only .button{
    width: 100%;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/AdminCode/commands.vue